"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _ui = require("@probeton/ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    card: {// maxWidth: 345,
    },
    media: {
      paddingTop: "".concat(Math.round(900 / 16), "%")
    }
  };
});

var UnitCard = function UnitCard(_ref) {
  var contactAvatar = _ref.contactAvatar,
      contactName = _ref.contactName,
      name = _ref.name,
      email = _ref.email,
      phone = _ref.phone,
      address = _ref.address,
      onOpen = _ref.onOpen;
  return /*#__PURE__*/_react["default"].createElement(_ui.ContactCard, {
    avatarUrl: contactAvatar,
    fullName: name,
    subheader: contactName,
    email: email,
    phone: phone,
    onClick: onOpen
  });
};

UnitCard.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  avatarUrl: _propTypes["default"].string,
  fullName: _propTypes["default"].string.isRequired,
  email: _propTypes["default"].string
};
UnitCard.defaultProps = {
  className: ''
};
var _default = UnitCard;
exports["default"] = _default;